import clsx from 'clsx';
import React from 'react';

import { LoadingPanel } from '../Loading';
import { Layout } from './Layout';

/**
 * Page main landmark
 */
export const PageMain = React.forwardRef<
    HTMLElement,
    { children: React.ReactNode; suspense?: boolean; wide?: boolean } & React.ComponentProps<'main'>
>(function PageMain(props, ref) {
    const { suspense = true, wide = false, className, ...rest } = props;

    const main = (
        <main
            ref={ref}
            {...rest}
            className={clsx('flex w-full flex-col gap-10 pt-6 pb-10 md:pt-10 md:pb-16', className)}
        />
    );
    return (
        <Layout wide={wide}>
            {suspense ? (
                <React.Suspense fallback={<LoadingPanel size="large" />}>{main}</React.Suspense>
            ) : (
                main
            )}
        </Layout>
    );
});
